import { render, staticRenderFns } from "./ChatDateTime.vue?vue&type=template&id=6e0b2512&scoped=true&"
import script from "./ChatDateTime.vue?vue&type=script&lang=js&"
export * from "./ChatDateTime.vue?vue&type=script&lang=js&"
import style0 from "./ChatDateTime.vue?vue&type=style&index=0&id=6e0b2512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0b2512",
  null
  
)

export default component.exports